import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Forthcoming from './Forthcoming';
import Developments from './Developments';
import Map from './Map';

const Content = ({ forthcoming, developments, map, error, query, onMarkerClick }) => {
  if (map) {
    return (
      <Map
        developments={developments}
        forthcoming={forthcoming}
        onMarkerClick={(d) => onMarkerClick && onMarkerClick(d)}
        error={error}
      />
    );
  }
  if (forthcoming) {
    return <Forthcoming developments={developments} error={error} />;
  }
  return <Developments developments={developments} search={query} error={error} />;
};

Content.propTypes = {
  developments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ),
  forthcoming: PropTypes.bool.isRequired,
  map: PropTypes.bool,
  error: PropTypes.string,
  query: PropTypes.string,
  onMarkerClick: PropTypes.func,
};

class DevelopmentContent extends Component {
  static propTypes = {
    developments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
      })
    ),
    forthcoming: PropTypes.bool,
    portfolio: PropTypes.bool,
    loadError: PropTypes.bool,
    error: PropTypes.string,
    query: PropTypes.string,
    onMarkerClick: PropTypes.func,
  };

  static defaultProps = {
    forthcoming: false,
  };

  state = {};

  showMap = () => {
    this.setState({ map: true });
  };

  showList = () => {
    this.setState({ map: false });
  };

  render() {
    return (
      <Fragment>
        <div className="container">
          <div className="col-sm-8 col-md-9">
            <h1>
              {this.props.forthcoming
                ? 'Coming Soon'
                : this.props.portfolio
                ? 'Portfolio'
                : 'Current Developments'}
            </h1>
          </div>
          {this.props.onMarkerClick && (
            <div className="col-sm-4 col-md-3 map-list clearfix">
              <div className="pull-right btn-group" role="group">
                <button
                  type="button"
                  className={`btn btn-default btn-lg${this.state.map ? ' active' : ''}`}
                  onClick={this.showMap}
                >
                  Map <span className="icon-map-marker" />
                </button>
                <button
                  type="button"
                  className={`btn btn-default btn-lg${this.state.map ? '' : ' active'}`}
                  onClick={this.showList}
                >
                  List <span className="icon-bars" />
                </button>
              </div>
            </div>
          )}
        </div>
        {this.props.loadError && (
          <p>
            An error occurred while loading {this.props.forthcoming ? 'forthcoming' : ''}{' '}
            developments.
          </p>
        )}
        <Content
          map={this.state.map}
          error={this.props.error}
          developments={this.props.developments}
          forthcoming={this.props.forthcoming}
          onMarkerClick={this.props.onMarkerClick}
          query={this.props.query}
        />
      </Fragment>
    );
  }
}

export default DevelopmentContent;
